<template >
    <div class="container">
    <!-- Outer Row -->
    <div class="row justify-content-center">
      <div class="col-xl-10 col-lg-12 col-md-9">
        <div class="card o-hidden border-0 shadow-lg my-5">
          <div class="card-body p-0">
            <div class="row">
              <div class="col-lg-12">
                <div class="p-5">
                  <div class="text-center">
                    <h1 class="h4 text-gray-900 mb-4">
                      <span v-if="teacherId!=null && teacherId!='' && teacherId!='new'">Багшийн мэдээлэл засах</span>
                      <span v-else>Багш нэмэх</span>
                    </h1>
                  </div>
                  <form class="user">
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Багшийн нэр: </label>
                        <input v-model.trim="teacher.name" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Багшийн нэр">
                      </div>
                      <div class="col-md-6 col-sm-12form-group">
                        <label>Багшийн овог: </label>
                        <input v-model.trim="teacher.lastname" type="text" class="form-control" id="exampleInputEmail" aria-describedby="emailHelp" placeholder="Багшийн овог">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Багшийн код: </label>
                        <input v-if="teacher.id && teacher.id!=''" readonly v-model.trim="teacher.code" type="text" class="form-control"  placeholder="Багшийн код">
                        <input v-else v-model.trim="teacher.code" type="text" class="form-control"  placeholder="Багшийн код">
                      </div>
                      <div class="col-md-6 col-sm-12 form-group" >
                        <label>Багшийн имэйл: </label>
                        <input  v-if="teacher.id && teacher.id!=''" readonly v-model.trim="teacher.email" type="text" class="form-control"  placeholder="Имэйл">
                        <input v-else v-model.trim="teacher.email" type="text" class="form-control"  placeholder="Имэйл">
                      </div>
                    </div>
                    <div class="row">
                      <div class="col form-group">
                        <label>Багшийн утасны дугаар: </label>
                        <input v-model.trim="teacher.phone" type="text" class="form-control"  placeholder="Утасны дугаар">
                      </div>
                  
                    </div>
                    <div class="row">
                      <div class="col col-md-6 col-sm-12 form-group">
                        <label for="exampleFormControlSelect1">Секц:</label>
                        <select class="form-control" v-model='teacher.sector'>
                          <option v-for="type in sectors" v-bind:key="'sector-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                      <div class="col col-md-6 col-sm-12 form-group">
                        <label for="exampleFormControlSelect1">Албан тушаал:</label>
                        <select class="form-control" v-model='teacher.position'>
                          <option v-for="type in positions" v-bind:key="'position-'+type.id" v-bind:value="type.ref">{{type.name}}</option>
                        </select>
                      </div>
                    </div>
                    
                    <div class="form-group">
                      <label>Xаяг: </label>
                      <textarea v-model.trim="teacher.address" type="text" class="form-control"  placeholder="Гэрийн хаяг"></textarea>
                    </div>
      
          
                   
                    <hr/>
                    <h4>Танилцуулга</h4>
                    <div class="row">
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Багшийн танилцуулга нэр: </label>
                        <input v-model.trim="teacher.firstName" type="text" class="form-control" aria-describedby="emailHelp" placeholder="Багшийн танилцуулга нэр">
                      </div>
                      <div class="col-md-6 col-sm-12 form-group">
                        <label>Багшийн танилцуулга овог: </label>
                        <input v-model.trim="teacher.lastName" type="text" class="form-control" aria-describedby="emailHelp" placeholder="Багшийн танилцуулга овог">
                      </div>
                    </div>
                    <div class="form-group">
                        <label>Багшийн танилцуулга текст: </label>
                    
                        <textarea v-model.trim="teacher.description" class="form-control"></textarea>
                    </div>


                    <div class="row">
                      <div class="text-center col">
                        <a class="small" href="#" @click="$router.back()">Буцах</a>
                      </div>
                      <div class="col">
                        <div @click="save" class="btn btn-primary">
                          Хадгалах
                        </div>
                      </div>
                    </div>
                    <hr>
                   
                  </form>

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>

    </div>

  </div>
</template>

<script>
const fb = require('../firebaseConfig.js');
import { mapState } from 'vuex'
export default {
    name: "TeacherAdd",
    data() {
        return {
            teacher: {
                name: '',
                lastname:'',
                phone:'',
                code:'',
                email:'',
                address:'',
                sector:null
 
            },
            performingRequest:false,
            cities:[],
            city:null,
            district:null,
            school:null,
            schools:[],
            sectors:[],
            positions:[]
        };
    },
    watch:{
      'teacher.sector':function(val){
        this.positions=[];
        if(val && val.id){
          val.collection("positions").orderBy("name").get().then(docs=>{
            
            docs.docs.forEach(value=>{
              if(value && value.exists){
                let position=value.data();
                position.id=value.id;
                position.ref=value.ref;
                this.positions.push(position);
              }
            });
          });
        }
      }
    },
    computed: {
        ...mapState(['userProfile', 'currentUser'])
    },
    methods: {
        async save() {
            this.performingRequest = true
            if(this.teacher!=null && this.teacher.name!='' && this.teacher.code!='' && this.teacher.sector){
              if(this.teacher.id!=null && this.teacher.id!='' && this.teacher.id!='new'){
                this.teacher.modified=fb.usersCollection.doc(this.$store.getters.currentUser.uid)
                this.teacher.modifiedAt=new Date();
                // console.log(this.techer)
                // if(this.city!=null)
                //  this.teacher.city=this.city.ref;
                
                // if(this.district!=null)
                //   this.teacher.district=this.district.ref
                
                if(this.schoolId)
                  this.teacher.school=fb.db.collection("schools").doc(this.schoolId);
                
                await fb.db.collection("schools/"+this.schoolId+"/teachers").doc(this.teacher.id).set(this.teacher)
                this.$router.back();
              }
              else{
                this.teacher.code=this.teacher.code.toLowerCase();

                var ts=await fb.db.collection("schools/"+this.schoolId+"/teachers").where("code", "==", this.teacher.code).limit(1).get();
                if(ts.empty){
                  this.teacher.created=fb.usersCollection.doc(this.$store.getters.currentUser.uid);
                  this.teacher.createdAt=new Date()
                  // if(this.city!=null){
                  //   this.teacher.city=this.city.ref;
                  //   this.city.ref.update({numberOfTeachers: fb.firestore.FieldValue.increment(1)});
                  // }
                  // if(this.district!=null){
                  //   this.teacher.district=this.district.ref;
                  //   this.district.ref.update({numberOfTeachers: fb.firestore.FieldValue.increment(1)});
                  // }
                  if(this.schoolId){
                    this.teacher.school=fb.db.collection("schools").doc(this.schoolId);
                    fb.db.collection("schools").doc(this.schoolId).update({numberOfTeachers: fb.firestore.FieldValue.increment(1)});
                  }
          
                  await fb.db.collection("schools/"+this.schoolId+"/teachers").doc().set(this.teacher);
                  this.$router.back();
                }
                else
                  alert(this.teacher.code+" кодтой багш бүртгэгдсэн байна.");

 
              }
         
              
            }
            else{
              alert("Та багшийн овог, нэр , имэйл , код болон секц мэдээлэл заавал оруулна уу");
            }
        },
        setteacher(){
          this.teacher= {
              name: '',
              lastname:'',
              phone:'',
              phone2:'',
              code:'',
              email:'',
              address:''
          }
        },
       
        remove(index, array){
          if(array!=null && array.length>0)
            array.splice(index, 1)
        },

        async _getteacher(){
          if(this.schoolId){
            fb.db.collection("schools/"+this.schoolId+"/sectors").orderBy("name").get().then(docs=>{
              this.sectors=[];
              if(docs && !docs.empty){
                docs.docs.forEach(value=>{
                  if(value && value.exists){
                    let item=value.data();
                    item.id=value.id;
                    item.ref=value.ref;
                    this.sectors.push(item);
                  }
                });
              }
            });
          }
          if(this.teacherId!=null && this.teacherId!='' && this.teacherId!='new'){
            var teacherData=await fb.db.collection("schools/"+this.schoolId+"/teachers").doc(this.teacherId).get();
            let object=teacherData.data();
            object.id=teacherData.id
            this.teacher=object;
          }
        },
    }, 
    props: {
        teacherId: { 
            required: false,
        },
        schoolId:{
          required:true
        }
    },
    created() {
        this._getteacher();     
    },
  
};
</script>

